module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/react-dates/~/es-to-primitive/helpers/isPrimitive.js
 ** module id = 1036
 ** module chunks = 0
 **/